import "./sentry";
import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./i18n/i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <React.StrictMode>
    {/* <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}> */}
    <App />
    {/* </Sentry.ErrorBoundary> */}
  </React.StrictMode>,
  document.getElementById("root"),
);

reportWebVitals();
